import React, { useState } from 'react';
import EntraRoles from './EntraRoles';

const SERVICE_TABS = [
  {
    id: 'entra-roles',
    label: 'Entra Roles',
    component: <EntraRoles />,
  },
  // Future tracking sections (e.g. CA Policies) can be added here
];

const ServiceTracking = () => {
  const [activeSection, setActiveSection] = useState(SERVICE_TABS[0].id);

  const activeTab = SERVICE_TABS.find(t => t.id === activeSection);

  return (
    <div className="st-container">
      <div className="st-header">
        <h2 className="st-title">Features</h2>
        <p className="st-subtitle">
          Track changes to Microsoft cloud service configurations, including Entra roles, Conditional Access policies, and more.
        </p>
      </div>

      <div className="st-sub-nav">
        {SERVICE_TABS.map(tab => (
          <button
            key={tab.id}
            className={`st-sub-nav-btn${activeSection === tab.id ? ' active' : ''}`}
            onClick={() => setActiveSection(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="st-content">
        {activeTab ? activeTab.component : null}
      </div>
    </div>
  );
};

export default ServiceTracking;
